import React, { useState } from "react";
import Fingerprint from "../../assets/fingerprint.svg";
import useAuth from "../../contexts/UserContext.tsx";

const Login = () => {
  const { login } = useAuth();
  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const apiLoginHandler = async (e) => {
    e.preventDefault();
    login(user.username, user.password);
  };

  return (
    <section className="h-screen">
      <div className="container px-6 py-12 h-full">
        <div className="flex justify-center items-center flex-wrap g-6 text-gray-800 sm:my-2">
          <div className="md:w-8/12 lg:w-6/12 mb-12 md:mb-0">
            <img src={Fingerprint} className="w-full" alt="" />
          </div>
          <div className="md:w-8/12 lg:w-5/12 lg:ml-20">
            <form>
              <div className="mb-6">
                <input
                  type="text"
                  className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Username"
                  value={user.username}
                  onChange={(e) =>
                    setUser((prev) => {
                      return { ...prev, username: e.target.value };
                    })
                  }
                  autoComplete="true"
                />
              </div>
              <div className="mb-6">
                <input
                  type="password"
                  value={user.password}
                  onChange={(e) =>
                    setUser((prev) => {
                      return { ...prev, password: e.target.value };
                    })
                  }
                  className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Password"
                  autoComplete="true"
                />
              </div>
              <button
                data-mdb-ripple="true"
                data-mdb-ripple-color="light"
                onClick={apiLoginHandler}
                className="inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out w-full"
              >
                Sign in
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
